import { Radio } from 'alurkerja-ui'
import { stringToTitleCase } from '@/utils/functions/stringToTitleCase'
import React from 'react'

type EditOrientationProps = {
  index: number
  element: string
  currentElementState: any
  setCurrentElementState: React.Dispatch<any>
}
export default function EditOrientation(props: EditOrientationProps) {
  const { index, element, currentElementState, setCurrentElementState } = props
  return (
    <div key={index} className="p-3 py-2 rounded-sm ">
      <span className="font-semibold">{stringToTitleCase(element)}</span>
      <Radio
        listOption={[
          {
            label: 'Horizontal',
            key: 'horizontal',
          },
          {
            label: 'Vertical',
            key: 'vertical',
          },
        ]}
        defaultValue={currentElementState[element]}
        onChange={(value) => {
          setCurrentElementState((prevState: any) => {
            return {
              ...prevState,
              [element]: value,
            }
          })
        }}
      />
    </div>
  )
}
